import { render } from "./Years.vue?vue&type=template&id=2201367c&scoped=true"
import script from "./Years.vue?vue&type=script&lang=js"
export * from "./Years.vue?vue&type=script&lang=js"

import "./Years.vue?vue&type=style&index=0&id=2201367c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2201367c"

export default script